import { render, staticRenderFns } from "./ChartDoughnut.vue?vue&type=template&id=2c33dcc0&scoped=true&"
import script from "./ChartDoughnut.vue?vue&type=script&lang=js&"
export * from "./ChartDoughnut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c33dcc0",
  null
  
)

export default component.exports